

import {Component, Vue} from 'vue-property-decorator';

import ModalAccept from '@/components/modal-accept/index.vue';
import Loader from "@/components/loader/Loader.vue";
import user_module from "@/modules/user";
import InputText from '@/components/input2/index.vue';
import Strengthmeter from '@/components/strengthmeter/index.vue';
import {checkPasswordStrength} from '@/lib/checkPasswordStrength'
import 'vue-toasted';

Vue.component("InputText", InputText);

@Component({
    components: {
      ModalAccept,
      Loader,
      Strengthmeter
    }
})

export default class Change extends Vue {
  public oldPassword: string = '';
  public newPassword: string = '';
  public repeatNewPassword: string = '';
  public error: string = '';
  public evokedModal: boolean = false;
  public Pin: number | string = '';
  public headerText: string = "Verification";
  public loading: boolean = false

  get didnotmatch(){

    return this.newPassword !== this.repeatNewPassword;
  }
  
  get passwordStrength(){

    return checkPasswordStrength(this.newPassword);

}

  get repeatPasswordStrength(){

    return checkPasswordStrength(this.repeatNewPassword);
    
  }

  get headerSubtext(){

    return `We've emailed verification code to you. Please check your inbox ${this.Email} and type it below.`;
    }

  get Login(){
    return user_module.login;
  }

  get Email(){
    return user_module.userInfo.Email || '';
  }

  
  
  get disabled(){

    return !this.oldPassword || !this.newPassword || !this.repeatNewPassword || !this.passwordStrength || !this.repeatPasswordStrength || this.didnotmatch;
  }

  reject(){

    this.evokedModal = false;

  }

  setError() {
    this.error = 'Fill in this field please'
  }

  async updateContinue(Pin: string | number) {

      this.loading = true;

      try{
      
          const result = await user_module.changePassword({newPassword: this.newPassword, Pin});

          if (result === 'Success'){

              this.evokedModal = false;

              const externalredirect = this.$route.query.externalredirect;

              if (externalredirect && typeof externalredirect === 'string'){
      
                if (externalredirect.toLowerCase() === 'ira'){

                    window.location.href = 'https://rixtrema.net/irafiduciaryoptimizer/account';

                } else {

                    window.location.href = externalredirect

                }

              }

              this.$router.push('/');

          } else {

              this.$toasted.error(result, {
                  duration: 4000
              });

              console.log('result err!!!', result)

              if (result === 'New password cannot repeat last 3 passwords'){

                  this.evokedModal = false;
              }
          }
          console.log('result', result);

      } catch(err){

          console.log('err', err);

            const {responseText} = err.request;

            if (responseText){

                const text = JSON.parse(responseText);
                
                const {Message} = text;

                        
                this.$toasted.error(Message, {
                    duration: 4000
                });


                if (Message !== 'Invalid PIN'){

                    this.evokedModal = false;
                }

            } else {
                                        
                this.$toasted.error(err, {
                    duration: 4000
                });

            }

      }

      this.loading = false;


  }

  preupdate(){

    if (this.disabled) return;

    if (this.newPassword !== this.repeatNewPassword){

        this.$toasted.error('Passwords do not match', {
            duration: 3000
        }); 

    } else if (this.newPassword.length < 8 || !/\d/.test(this.newPassword)){

        this.$toasted.error('Password must be minimum of 8 characters, with at least one number', {
            duration: 3000
        }); 

    } else if (this.newPassword === this.oldPassword){

        this.$toasted.error('New password must be different from old password', {
            duration: 3000
        }); 

    } else {

        this.update();
    }
  }

  async update() {

      this.loading = true

      try{

          const result = await user_module.preChangePassword(this.oldPassword);

          if (result === 'Success'){

            this.evokedModal = true;

            this.$toasted.show('<b>Success!</b>', {
                duration: 4000
            });
          }

          if (result === 'Invalid password'){

              this.$toasted.error('Wrong password', {
                  duration: 4000
              });
          }

          console.log('result', result);

      } catch(err){

          console.log('err', err);
          this.$toasted.error('Wrong password', {
              duration: 4000
          });


      }

      this.loading = false;

   

  }

  btn2Click(){

      console.log('btn2Click');
  }
}
